<template>
  <a
    :id="id"
    :href="url"
    :class="[classes, 'ah-link-button']"
    v-bind="$attrs"
    :target="target"
    :title="title"
    :data-tracking="tracking"
    @click="handleClick"
  >
    <slot />
  </a>
</template>

<script>
  export default {
    name: 'AhLink',
    props: {
      url: {
        type: String,
        required: true
      },
      tracking: {
        type: String,
        default: ''
      },
      classes: {
        type: String,
        default: ''
      },
      target: {
        type: String,
        default: null
      },
      title: {
        type: String,
        default: null
      },
      id: {
        type:String,
        default: null
      },
    },
    methods: {
      handleClick () {
        this.$emit('ah-link-clicked');
      }
    }
  };
</script>
